import React from 'react';
import PropTypes from 'prop-types';
import ButtonEdit from '../ButtonEdit';
import View from './View';
import Edit from './Edit';
import { usStatePropType } from '../Insured/StateField';

const InsuranceContact = ({
  edit,
  confirm,
  enabled,
  confirmed,
  contactSame,
  contactRenter,
  contactPhone,
  contactEmail,
  contactFirstName,
  contactLastName,
  contactCompany,
  contactAddress,
  contactCity,
  contactState,
  contactZip,
  contactCountry,
  valid,
  usStates,
  paymentInfoRef,
  insuranceContactRef,
  scrollToPosition,
}) => {
  return (
    <div
      className={`component ${enabled ? 'enabled' : 'disabled'}`}
      ref={insuranceContactRef}
    >
      <div className="form-row justify-content-between">
        <div className="col-auto my-auto">
          <h3>Insurance Contact</h3>
        </div>
        <ButtonEdit edit={edit} show={confirmed} />
      </div>
      <div className="card">
        <div className="card-body">
          <Edit
            enabled={enabled}
            confirm={confirm}
            show={!confirmed}
            valid={valid}
            contactSame={contactSame}
            contactRenter={contactRenter}
            usStates={usStates}
            scrollToPosition={scrollToPosition}
            paymentInfoRef={paymentInfoRef}
          />
          <View
            contactRenter={contactRenter}
            contactPhone={contactPhone}
            contactEmail={contactEmail}
            contactSame={contactSame}
            contactFirstName={contactFirstName}
            contactLastName={contactLastName}
            contactCompany={contactCompany}
            contactAddress={contactAddress}
            contactCity={contactCity}
            contactState={contactState}
            contactZip={contactZip}
            contactCountry={contactCountry}
            show={confirmed}
          />
        </div>
      </div>
    </div>
  );
};

InsuranceContact.propTypes = {
  edit: PropTypes.func.isRequired,
  confirm: PropTypes.func.isRequired,
  enabled: PropTypes.bool.isRequired,
  confirmed: PropTypes.bool.isRequired,
  contactSame: PropTypes.bool.isRequired,
  contactRenter: PropTypes.bool.isRequired,
  contactPhone: PropTypes.string.isRequired,
  contactEmail: PropTypes.string.isRequired,
  contactFirstName: PropTypes.string.isRequired,
  contactCompany: PropTypes.string.isRequired,
  contactLastName: PropTypes.string.isRequired,
  contactAddress: PropTypes.string.isRequired,
  contactCity: PropTypes.string.isRequired,
  contactState: PropTypes.string.isRequired,
  contactZip: PropTypes.string.isRequired,
  contactCountry: PropTypes.string.isRequired,
  valid: PropTypes.bool.isRequired,
  usStates: usStatePropType.isRequired,
  scrollToPosition: PropTypes.func.isRequired,
  paymentInfoRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]).isRequired,
  insuranceContactRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]).isRequired,
};

export default InsuranceContact;
